//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../no/NXObject.js";
let d=[[],[[[],"LoadAll",{},0,0],[[],"LoadPreview",{},0,0],[[],"PopulateRows",{},0,0],[["nRows"],"GetRows",{R_:{rows:"NXObject[]"}},0,0],[["selectedResultObjects","nEngObjects"],"LoadAndRetrieveEngineeringObjects",{R_:{engObjects:"AME.AMEEngObject[]"}},1,0],[["selectedResultObjects","nTags","plcSymbols"],"LoadAndRetrievePlcSymbols",{},1,0],[["selectedModelIDs","nEngObjects"],"LoadEngineeringObjectsFromModelIds",{R_:{engObjects:"AME.AMEEngObject[]"}},1,0],[["selectedResultObjects","nTags","connections"],"LoadAndRetrieveConnections",{},1,0]],[]];
SPLM.AME.QueryResult = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.QueryResult";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;